<template>
    <a-drawer :title="title" width="1100" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-descriptions title="基本资料" bordered :column="4" size="middle">
            <a-descriptions-item label="昵称">
                {{ detail.name }}
            </a-descriptions-item>
            <a-descriptions-item label="ID">
                <a-tag color="#2db7f5">
                    {{ detail.id }}
                </a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="标签" :span="4">
                {{ detail.tags }}
            </a-descriptions-item>
            <a-descriptions-item label="实名认证" :span="2">{{ detail.cert.name }} [{{ detail.cert.sno }}]</a-descriptions-item>
            <a-descriptions-item label="会员级别" :span="2">
                {{ detail.level | fmtUserLevel }}
                <span v-if="detail.lvexp">[{{ detail.lvexp }}] 到期</span>
            </a-descriptions-item>
            <a-descriptions-item label="地址" :span="2">
                {{ detail.addr }}
            </a-descriptions-item>
            <a-descriptions-item label="手机号">
                {{ detail.mob }}
            </a-descriptions-item>
            <a-descriptions-item label="微信号">
                {{ detail.wxkey }}
            </a-descriptions-item>
            <a-descriptions-item label="QQ">
                {{ detail.qq }}
            </a-descriptions-item>
            <a-descriptions-item label="邮箱">
                {{ detail.email }}
            </a-descriptions-item>
            <a-descriptions-item label="性别">
                {{ detail.gender | fmtGender }}
            </a-descriptions-item>
            <a-descriptions-item label="头像" :span="2">
                <div v-if="detail.avatar" :style="{ width: '100px', height: '100px' }">
                    <img :src="detail.avatar" :style="{ width: '100%', height: '100%' }" />
                </div>
                <span v-else>未上传</span>
            </a-descriptions-item>
            <a-descriptions-item label="注册时间" :span="2">
                {{ detail.create }}
            </a-descriptions-item>
            <a-descriptions-item label="面咨费用">
                {{ detail.fee }}
            </a-descriptions-item>
            <a-descriptions-item label="出生日期">
                {{ detail.birth }}
            </a-descriptions-item>
            <a-descriptions-item label="婚姻状况">
                {{ detail.marry }}
            </a-descriptions-item>
            <a-descriptions-item label="籍贯">
                {{ detail.place }}
            </a-descriptions-item>
            <a-descriptions-item label="政治面貌">
                {{ detail.polit }}
            </a-descriptions-item>
            <a-descriptions-item label="工作单位">
                {{ detail.wunit }}
            </a-descriptions-item>
            <a-descriptions-item label="工作部门">
                {{ detail.wdept }}
            </a-descriptions-item>
            <a-descriptions-item label="从业年份">
                {{ detail.wyear }}
            </a-descriptions-item>
            <a-descriptions-item label="教授课程">
                {{ detail.course }}
            </a-descriptions-item>
            <a-descriptions-item label="导师性质">
                {{ detail.nature }}
            </a-descriptions-item>
            <a-descriptions-item label="职称">
                {{ detail.rank }}
            </a-descriptions-item>
            <a-descriptions-item label="职位">
                {{ detail.duty }}
            </a-descriptions-item>
            <a-descriptions-item label="毕业院校">
                {{ detail.school }}
            </a-descriptions-item>
            <a-descriptions-item label="所学专业">
                {{ detail.major }}
            </a-descriptions-item>
            <a-descriptions-item label="最高学历">
                {{ detail.edu }}
            </a-descriptions-item>
            <a-descriptions-item label="最高学位">
                {{ detail.degree }}
            </a-descriptions-item>
            <a-descriptions-item label="是否督导">
                {{ detail.superv ? '是' : '否' }}
            </a-descriptions-item>
            <a-descriptions-item label="导师等级">
                {{ detail.clv | fmtCtaLevel }}
            </a-descriptions-item>
            <a-descriptions-item label="研究方向" :span="2">
                {{ detail.resea }}
            </a-descriptions-item>
            <a-descriptions-item label="社会任职" :span="2">
                {{ detail.jobs }}
            </a-descriptions-item>
            <a-descriptions-item label="知识产权" :span="2">
                {{ detail.ipr }}
            </a-descriptions-item>
            <a-descriptions-item label="科研著作" :span="2">
                {{ detail.works }}
            </a-descriptions-item>
            <a-descriptions-item label="影响力" :span="2">
                {{ detail.influ }}
            </a-descriptions-item>
            <a-descriptions-item label="专业实力" :span="2">
                {{ detail.stren }}
            </a-descriptions-item>
            <a-descriptions-item label="数据来源" :span="2">
                {{ detail.dsrc }}
            </a-descriptions-item>
            <a-descriptions-item label="来源网址" :span="2">
                {{ detail.durl }}
            </a-descriptions-item>
        </a-descriptions>
        <a-divider />
        <a-descriptions title="账号信息" bordered :column="1" size="middle">
            <a-descriptions-item label="是否绑定微信">
                {{ item.wxmp.bind ? '已绑定' : '未绑定' }}
            </a-descriptions-item>
            <a-descriptions-item label="微信绑定码" v-if="!item.wxmp.bind">
                {{ item.wxmp.code || '未设置绑定码或已过期' }}
            </a-descriptions-item>
            <a-descriptions-item label="绑定码过期" v-if="!item.wxmp.bind && item.wxmp.code">
                {{ item.wxmp.time }}
            </a-descriptions-item>
            <a-descriptions-item label="绑定二维码" v-if="!item.wxmp.bind && item.wxmp.code">
                <a-button type="primary" icon="cloud-download" @click="execDownQr">下载二维码</a-button>
            </a-descriptions-item>
            <a-descriptions-item label="最近登录IP">
                {{ item.last.ip || '未登录' }}
            </a-descriptions-item>
            <a-descriptions-item label="最近登录时间">
                {{ item.last.time || '未登录' }}
            </a-descriptions-item>
            <a-descriptions-item label="是否锁定">
                {{ item.lock.flg ? '已锁定' : '未锁定' }}
            </a-descriptions-item>
            <a-descriptions-item label="锁定原因" v-if="item.lock.flg">
                {{ item.lock.cause }}
            </a-descriptions-item>
            <a-descriptions-item label="锁定时间" v-if="item.lock.flg">
                {{ item.lock.time }}
            </a-descriptions-item>
            <a-descriptions-item label="解锁时间" v-if="item.lock.flg">
                {{ item.lock.resume }}
            </a-descriptions-item>
        </a-descriptions>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            detail: {
                cert: {},
                wxmp: {},
                last: {},
                lock: {}
            }
        }
    },
    mounted() {
        this.$http
            .get('/ums/plat/cta/detail', {
                params: {
                    id: this.item.id
                }
            })
            .then(result => {
                this.detail = result.data
            })
    },
    methods: {
        execDownQr() {
            if (this.detail.wxmp.qrst) {
                window.open('https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + this.detail.wxmp.qrst)
            }
        }
    }
}
</script>
